/* eslint-disable react/no-multi-comp */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { FavoriteWrapper } from 'subsys/favorites';
import Row, { Col } from 'components/row';
import Button from 'components/button';
import { iconTypes } from 'components/icon';

import TileCardObject from './tile-card-object';
import ListCard, { checkSold } from './list-card';

import translates from '../../section-projects/card-i18n';

const bemClassesProject = new Bem('project');
const dataMods = { domik: true, plans: true };

@I18nHoc(translates())
export default class Cards extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    termsArray: PropTypes.arrayOf(PropTypes.shape({})),
    type: PropTypes.string,
    addedWord: PropTypes.string,
    soldData: PropTypes.shape({}),
    projectData: PropTypes.shape({}),
    seoHeader: PropTypes.string,
    objClasses: PropTypes.any, // eslint-disable-line
    objTerms: PropTypes.any, // eslint-disable-line
    permObjManage: PropTypes.bool
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.changeCardView = this.changeCardView.bind(this);
    this.showHiddenPlans = this.showHiddenPlans.bind(this);

    this.state = {
      isViewTile: true,
      showSoldPlans: {}
    };
  }

  changeCardView() {
    this.setState({ isViewTile: !this.state.isViewTile });
  }

  showHiddenPlans(type) {
    const showSoldPlansAll = get(this, 'state.showSoldPlans');
    const showSoldPlansType = get(this, `state.showSoldPlans[${type}]`);
    showSoldPlansAll[type] = !showSoldPlansType;

    this.setState({ showSoldPlans: showSoldPlansAll });
  }

  render() {
    const { i18n } = this;
    const {
      data, projectData, type, addedWord, soldData, objClasses,
      objTerms, termsArray, seoHeader, permObjManage
    } = this.props;

    let filterObjClasses = data;
    if (data && objClasses) {
      if (type === 'flats') {
        filterObjClasses = filter(data, val => val.classesDict.abbrev === objClasses);
      } else if (
        type === 'houses' ||
        type === 'townhouses' ||
        type === 'garage' ||
        type === 'lands'
      ) {
        filterObjClasses = filter(data, val => get(val, 'classesDict.value_long') === objClasses);
      } else {
        filterObjClasses = filter(data, val => val.type_dict.entity_long === objClasses);
      }
    }

    const built_year = get(termsArray, `[${objTerms}].built_year`);
    const built_quarter = get(termsArray, `[${objTerms}].built_quarter`);
    const nowYear = new Date().getFullYear();
    const nowMoth = new Date().getMonth();
    const nowQuarter = Math.floor(nowMoth / 3) + 1;
    const isFuture = built_year > nowYear || (built_year === nowYear && built_quarter > nowQuarter);
    const isPastAndCurrent = built_year < nowYear || (built_year === nowYear && built_quarter <= nowQuarter);

    let filterObjTerms = filterObjClasses;

    if (isPastAndCurrent) {
      const notReady = filter(
        filterObjTerms,
        val => get(val, 'house_properties.house_status_ready') !== true
      );

      const oldYear = filter(
        notReady,
        val => get(val, 'house_properties.built_year') < nowYear
      );

      const currentYear  = filter(
        notReady,
        val => {
          if (get(val, 'house_properties.built_year') === nowYear){
            return get(val, 'house_properties.built_quarter') <= nowQuarter;
          }
        }
      );
      filterObjTerms = [...oldYear, ...currentYear];
    }

    if (isFuture) {
      filterObjTerms = filter(
        filterObjTerms,
        val => get(val, 'house_properties.built_year') === built_year
      );
      filterObjTerms = filter(
        filterObjTerms,
        val => get(val, 'house_properties.built_quarter') === built_quarter
      );
      filterObjTerms = filter(
        filterObjTerms,
        val => get(val, 'house_properties.house_status_ready') !== true
      );
    }
    if (objTerms === 0 && termsArray[0].value === i18n('readyText')) {
      filterObjTerms = filter(
        filterObjTerms,
        val => get(val, 'house_properties.house_status_ready') === true
      );
    }

    if (!filterObjTerms || filterObjTerms.length === 0) {
      return (
        <div {...bemClassesProject('noData')}>
          <span {...bemClassesProject('text')} children={i18n('noOffersText')} />
        </div>
      );
    }

    const { isViewTile } = this.state;
    const sortedObj = {};
    const sortBySquare = sortBy(filterObjTerms, item => item.object_properties.all_area);
    const sortBySold = sortBy(sortBySquare, item => +item.all_flats_sold_object);
    const sortData = sortBy(sortBySold, item => get(item, 'classesDict.sort_order'));

    map(sortData, (val) => {
      const value_long = get(val, 'classesDict.value_long');
      let groupName = value_long || val.type_dict.entity_long;
      if (type === 'comm') groupName = val.type_dict.entity_long;
      if (addedWord) groupName = `${addedWord} ${groupName}`;
      if (typeof sortedObj[groupName] === 'undefined') {
        sortedObj[groupName] = [];
      }
      sortedObj[groupName].push(val);
    });

    let keyNumber = 0;

    return map(sortedObj, (val, key) => {
      const topic = <div {...bemClassesProject('text', 'h2')}><h2 children={seoHeader || key} /></div>;
      keyNumber += 1;

      return (
        <Fragment key={key}>
          <Row {...bemClassesProject('rowTopic')}>
            <Col allPr={0} children={topic} />
            {keyNumber === 1 &&
              <Col allAuto allPr={0} children={renderBtnsView.call(this, bemClassesProject)} />
            }
          </Row>
          <div {...bemClassesProject('paginator', { tile: isViewTile, list: !isViewTile })}>
            {isViewTile && renderTileCard.call(this, val, key, soldData, projectData)}
            {!isViewTile &&
              renderListCard.call(this, val, key, soldData, permObjManage, projectData)
            }
          </div>
        </Fragment>
      );
    });
  }
}

function renderTileCard(val, type, soldData, projectData) {
  const showSold = get(this, `state.showSoldPlans[${type}]`);
  const group = get(val, '[0].$entity');
  const isSoldBtnNeeded = checkIsSoldBtnNeeded.call(this, val, soldData, group);

  return (
    <>
      <FavoriteWrapper
        project="domik"
        entity="object"
      >
        {({ data }) => map(val, (item, key) => {
          const groupType = item.$entity;
          const sold = checkSold.call(this, item.all_flats_sold_object, soldData, groupType);

          return (
            <TileCardObject
              key={key}
              object={item}
              projectData={projectData}
              dataMods={{ ...dataMods, sold: sold.sold, visible: !sold.sold || showSold }}
              favData={data}
              soldData={soldData}
              noHover
            />
          );
        })}
      </FavoriteWrapper>
      {isSoldBtnNeeded &&
        renderSoldBtn.call(this, type, showSold)
      }
    </>
  );
}

function checkIsSoldBtnNeeded(val, soldData, group) {
  let isExistSold = false;

  for (let i = 0; i < val.length; i += 1) {
    const sold = checkSold.call(this, get(val, `[${i}].all_flats_sold_object`) || get(val, `[${i}].data.allSold`), soldData, group);
    if (sold.sold) {
      isExistSold = true;
      break;
    }
  }
  return isExistSold;
}

function renderSoldBtn(type, showSold) {
  const { i18n } = this;
  const mods = this.state.isViewTile ?
    { viewTile: true, open: showSold } :
    { viewList: true, open: showSold };
  const btnTxt = showSold ? i18n('btnCardSoldHide') : i18n('btnCardSoldShow');

  return (
    <Button
      {...bemClassesProject('btn', mods)}
      onClick={() => this.showHiddenPlans(type)}
      label={btnTxt}
      iconSecondType={iconTypes.carretBild}
    />
  );
}

export function getSoldTxt(project) {
  const { i18n } = this;
  const { all_flats_sold, sales_suspended_until } = project;
  let soldTxt = all_flats_sold ? i18n('allFlatsSoldTile') : '';

  if (!all_flats_sold && sales_suspended_until) soldTxt = i18n('salesSuspendedUntil');

  return soldTxt;
}

export function renderListCard(val, type, soldData, permObjManage, projectData) {
  const showSold = get(this, `state.showSoldPlans[${type}]`);
  const group = get(val, '[0].$entity') || type;
  const isSoldBtnNeeded = checkIsSoldBtnNeeded.call(this, val, soldData, group);

  return (
    <>
      <FavoriteWrapper
        project="domik"
        entity="object"
      >
        {({ data }) => map(val, (item, key) => {
          const groupType = item.$entity || type;
          const sold = checkSold.call(this, item.all_flats_sold_object || get(item, 'data.allSold'), soldData, groupType);

          return (
            <ListCard
              key={key}
              object={item}
              projectData={projectData}
              type={type}
              soldData={soldData}
              dataMods={{ ...dataMods, visible: !sold.sold || showSold }}
              favData={data}
              permObjManage={permObjManage}
            />
          );
        })}
      </FavoriteWrapper>
      {isSoldBtnNeeded && renderSoldBtn.call(this, type, showSold)}
    </>
  );
}

function renderBtnsView(bemClass) {
  const { i18n } = this;
  const { isViewTile } = this.state;

  return (
    <div {...bemClass('btnsView')}>
      <Button
        {...bemClass('btn', { view: true, active: !isViewTile })}
        onClick={this.changeCardView}
        title={i18n('btnViewListTitle')}
        iconType={iconTypes.viewListBild}
      />
      <Button
        {...bemClass('btn', { view: true, active: isViewTile })}
        onClick={this.changeCardView}
        title={i18n('btnViewTileTitle')}
        iconType={iconTypes.viewTileBild}
      />
    </div>
  );
}
